import type { CreateObjectStepId } from 'entities/kyrgyzstan/model/create-object'

export const Avia = ''
export const Excursions = 'excursions'
export const Beket = 'beket'
export const Kyrgyzstan = 'kyrgyzstan'
export const Tours = 'tours'
export const Umrah = 'umrah'

export const RoutingPaths = {
  base: () => Avia,

  path: () => `/`,

  profile: {
    base: () => 'profile',

    path: () => `${RoutingPaths.path()}profile`,
    edit: {
      base: () => `${RoutingPaths.profile.base()}/edit/:type`,

      path: (type: string | undefined) =>
        `${RoutingPaths.profile.path()}/edit/${type}`,
    },

    view: {
      base: () => `${RoutingPaths.profile.base()}/view/:type`,

      path: (type: string | undefined) =>
        `${RoutingPaths.profile.path()}/view/${type}`,
    },
  },

  events: {
    // football: {
    //   base: () => 'football',
    //   path: () => `${RoutingPaths.path()}football`,
    // },
  },

  profileDetail: {
    base: () => 'detail-profile',
    path: () => `${RoutingPaths.path()}detail-profile`,
  },

  promo: {
    base: () => ':id',

    path: (id: string) => `${RoutingPaths.path()}${id}`,
  },

  feedback: {
    base: () => 'feedback',

    path: () => `${RoutingPaths.path()}feedback`,
  },

  offers: {
    base: () => 'offers',

    path: () => `${RoutingPaths.path()}offers`,
  },

  payment: {
    base: () => 'payment_success',

    path: () => `${RoutingPaths.path()}payment_success`,
  },

  avia: {
    base: () => 'avia',

    path: () => `avia`,

    blackFriday: {
      base: () => 'black-friday',

      path: () => `/${RoutingPaths.avia.path()}/black-friday`,
    },

    mplus: {
      base: () => 'mplus',
      path: () => `/${RoutingPaths.avia.path()}/mplus`,
    },

    minstalment: {
      base: () => 'minstalment',
      path: () => `/${RoutingPaths.avia.path()}/minstalment`,
    },

    search: {
      base: () => 'search',

      path: () => `/${RoutingPaths.avia.path()}/search`,
    },

    searchWidget: {
      base: () => 'search/:params',

      path: (params: string) => `/${RoutingPaths.avia.path()}/search/${params}`,
    },

    purchase: {
      base: () => 'purchase',

      page: () => '/',

      path: () => `/${RoutingPaths.avia.path()}/purchase`,

      check: {
        base: () => 'check',

        path: () => `${RoutingPaths.avia.purchase.path()}/check`,
      },

      tickerDetail: {
        base: () => 'detail-ticket',

        path: () => `${RoutingPaths.avia.purchase.path()}/detail-ticket`,
      },

      tickerCertificate: {
        base: () => 'certificate',

        path: () => `${RoutingPaths.avia.purchase.path()}/certificate`,
      },
    },

    myTickets: {
      base: () => 'my_tickets',

      path: () => `/${RoutingPaths.avia.path()}/my_tickets`,

      detail: {
        base: () => 'my_ticket/:type/:id/:appealId/*',

        path: (id: string, appealId?: string, type?: 'archive' | 'active') =>
          `/${RoutingPaths.avia.path()}/my_ticket/${type || 'active'}/${id}${appealId ? `/${appealId}` : ''}`,
      },
    },

    filter: {
      base: () => 'filter',

      page: () => '/',

      path: () => `/${RoutingPaths.avia.path()}/filter`,

      airport: {
        base: () => 'airport',

        path: () => `${RoutingPaths.avia.filter.path()}/airport`,
      },

      timer: {
        base: () => 'timer',

        path: () => `${RoutingPaths.avia.filter.path()}/timer`,
      },

      aircompany: {
        base: () => 'aircompany',

        path: () => `${RoutingPaths.avia.filter.path()}/aircompany`,
      },

      transfers: {
        base: () => 'transfers',

        path: () => `${RoutingPaths.avia.filter.path()}/transfers`,
      },

      price: {
        base: () => 'price',

        path: () => `${RoutingPaths.avia.filter.path()}/price`,
      },
    },

    calendar: {
      base: () => 'calendar-range',

      path: () => `/${RoutingPaths.avia.path()}/calendar-range`,
    },

    insuranceService: {
      base: () => 'insurance-service',

      path: () => `/${RoutingPaths.avia.path()}/insurance-service`,
    },

    popularDirection: {
      base: () => 'popular-direction',

      path: () => `/${RoutingPaths.avia.path()}/popular-direction`,
    },

    searchDirection: {
      base: () => 'search-direction/:direction',

      path: (direction: string) =>
        `/${RoutingPaths.avia.path()}/search-direction/${direction}`,
    },

    difficultRoute: {
      base: () => 'difficult-route',

      path: () => `/${RoutingPaths.avia.path()}/difficult-route`,
    },

    detailTicket: {
      base: () => 'detail-ticket',

      path: (index?: string) =>
        `/${RoutingPaths.avia.path()}/detail-ticket/?index=${index || ''}`,
    },

    searchForm: {
      base: () => 'search-form',

      path: () => `/${RoutingPaths.avia.path()}/search-form`,
    },

    scanPassword: {
      base: () => 'scan-password',

      path: () => `/${RoutingPaths.avia.path()}/scan-password`,
    },

    scanTunduk: {
      base: () => 'scan-tunduk',

      path: () => `/${RoutingPaths.avia.path()}/scan-tunduk`,
    },

    favorites: {
      base: () => 'favorites/*',

      page: () => '/',

      path: () => `/${RoutingPaths.avia.path()}/favorites`,

      detail: {
        base: () => ':favoriteId',

        path: (favoriteId: string) =>
          `${RoutingPaths.avia.favorites.path()}/${favoriteId}`,
      },
    },
  },

  closeCircle: {
    base: () => 'close-circle',

    path: () => `/close-circle`,

    start: () => '/',

    list: {
      base: () => '/',

      path: () => `/${RoutingPaths.closeCircle.base()}`,
    },

    detailCloseCircle: {
      base: () => '/:id',

      path: (id: string) => `/${RoutingPaths.base()}close-circle/${id}`,
    },

    form: {
      base: () => '/form',

      path: () => `/${RoutingPaths.closeCircle.base()}/form`,
    },

    detailFormDetail: {
      base: () => '/form/:id',

      path: (id: string) => `/${RoutingPaths.closeCircle.base()}/form/${id}`,
    },
  },

  insurance: {
    base: () => 'insurance',

    path: () => `/insurance`,

    application: {
      base: () => 'application',

      path: () => `/${RoutingPaths.insurance.base()}/application`,
    },

    country: {
      base: () => 'country',

      path: () => `/${RoutingPaths.insurance.base()}/country`,
    },

    calendar: {
      base: () => 'calendar',

      path: () => `/${RoutingPaths.insurance.base()}/calendar`,
    },

    program: {
      base: () => 'program',

      path: () => `/${RoutingPaths.insurance.base()}/program`,
    },

    policyholder: {
      base: () => 'policyholder',

      path: () => `/${RoutingPaths.insurance.base()}/policyholder`,
    },

    citizenship: {
      base: () => 'citizenship',

      path: () => `/${RoutingPaths.insurance.base()}/citizenship`,
    },

    scanPassport: {
      base: () => 'scan-passport',

      path: () => `/${RoutingPaths.insurance.base()}/scan-passport`,
    },

    calculation: {
      base: () => 'calculation',

      path: () => `/${RoutingPaths.insurance.base()}/calculation`,
    },
  },

  scan: {
    base: () => 'scan-password',

    path: () => `/${RoutingPaths.base()}/scan-password`,
  },

  myOrders: {
    base: () => 'my-orders',

    path: () => `${RoutingPaths.base()}/my-orders`,

    pathArchive: () => `/${RoutingPaths.myOrders.base()}/archive`,

    baseArchive: () => `my-orders/archive`,
  },

  icons: {
    base: () => 'icons',

    path: () => `/${RoutingPaths.base()}/icons`,
  },

  touraika: {
    base: () => 'touraika',

    path: () => `/touraika`,

    detail: {
      base: () => 'touraika/:id',

      path: (id: string) => `${RoutingPaths.touraika.path()}/${id}`,
    },
  },

  esim: {
    // `/*` lets deep links like `/esim/my-sims` reach the page; the rest of
    // the path is forwarded to the eSIM iframe.
    base: () => 'esim/*',

    path: (subPath?: string) => (subPath ? `/esim/${subPath}` : `/esim`),

    // "Мои eSIM" tab inside the eSIM iframe.
    mySims: {
      path: () => RoutingPaths.esim.path('my-sims'),
    },
  },

  excursion: {
    start: () => '/',

    base: () => Excursions,

    path: () => `/${Excursions}`,

    mplus: {
      base: () => 'mplus',
      path: () => `${RoutingPaths.excursion.path()}/mplus`,
    },

    excursionByDirection: {
      base: () => 'by-direction/:id',

      path: (id: string) =>
        `${RoutingPaths.excursion.path()}/by-direction/${id}`,
    },

    searchDirection: {
      base: () => 'search-directions',

      path: () => `${RoutingPaths.excursion.path()}/search-directions`,
    },

    filterCarrier: {
      base: () => 'filter-carrier',

      path: () => `${RoutingPaths.excursion.path()}/filter-carrier`,
    },

    guideDetail: {
      base: () => 'guide-detail/:id',

      path: (id: string) =>
        `${RoutingPaths.excursion.path()}/guide-detail/${id}`,
    },

    contentPage: {
      base: () => 'content-page',

      path: () => `${RoutingPaths.excursion.path()}/content-page`,
    },

    orderDetail: {
      base: () => 'order-detail',

      path: () => `${RoutingPaths.excursion.path()}/order-detail`,
    },

    customerDetails: {
      base: () => 'customer-details',

      path: () => `${RoutingPaths.excursion.path()}/customer-details`,
    },

    search: {
      base: () => 'search',

      path: () => `${RoutingPaths.excursion.path()}/search`,
    },

    filter: {
      base: () => 'filter',

      path: () => `${RoutingPaths.excursion.path()}/filter`,
    },

    calendar: {
      base: () => 'calendar',

      path: () => `${RoutingPaths.excursion.path()}/calendar`,
    },

    popular: {
      base: () => 'popular',

      path: () => `${RoutingPaths.excursion.path()}/popular`,
    },

    searchForm: {
      base: () => 'search-form',

      path: () => `${RoutingPaths.excursion.path()}/search-form`,
    },

    myOrder: {
      base: () => 'my-order',

      path: () => `${RoutingPaths.excursion.path()}/my-order`,

      detail: {
        base: () => 'my-order/:id',

        path: (id: string) => `${RoutingPaths.excursion.path()}/my-order/${id}`,
      },
    },
  },

  tours: {
    start: () => '/',

    base: () => Tours,

    path: () => `/${Tours}`,

    contract: {
      base: () => 'contract/:contractId',
      path: (contractId: string) =>
        `${RoutingPaths.tours.path()}/contract/${encodeURIComponent(contractId)}`,
    },

    searchDeparture: {
      base: () => 'search-departure',

      path: () => `${RoutingPaths.tours.path()}/search-departure`,
    },

    searchDirection: {
      base: () => 'search-directions',

      path: () => `${RoutingPaths.tours.path()}/search-directions`,
    },

    allDirections: {
      base: () => 'directions',

      path: () => `${RoutingPaths.tours.path()}/directions`,
    },

    searchForm: {
      base: () => 'search-form',

      path: () => `${RoutingPaths.tours.path()}/search-form`,
    },

    resortTypePage: {
      base: () => 'resort-type/:id',

      path: (id: string) => `${RoutingPaths.tours.path()}/resort-type/${id}`,
    },

    calendar: {
      base: () => 'calendar-range',

      path: () => `${RoutingPaths.tours.path()}/calendar-range`,
    },

    selectPeople: {
      base: () => 'select-people',

      path: () => `${RoutingPaths.tours.path()}/select-people`,
    },

    selectNights: {
      base: () => 'select-nights',

      path: () => `${RoutingPaths.tours.path()}/select-nights`,
    },

    tourDetail: {
      base: () => 'tour-detail/:hotelId',
      path: (hotelId: string) =>
        `${RoutingPaths.tours.path()}/tour-detail/${hotelId}`,

      baseShare: () => 'tour-detail-share/:sharingCode',
      pathShare: (sharingCode: string) =>
        `${RoutingPaths.tours.path()}/tour-detail-share/${sharingCode}`,
    },
    searchResults: {
      base: () => 'search-results',
      path: () => `${RoutingPaths.tours.path()}/search-results`,
    },

    specialTours: {
      base: () => 'special-tours',
      path: () => `${RoutingPaths.tours.path()}/special-tours`,
    },

    gallery: {
      base: () => 'gallery',
      path: () => `${RoutingPaths.tours.path()}/gallery`,
    },

    roomGallery: {
      base: () => 'room-gallery',
      path: () => `${RoutingPaths.tours.path()}/room-gallery`,
    },

    roomPreview: {
      base: () => 'room-preview',
      path: (index: number = 0) =>
        `${RoutingPaths.tours.path()}/room-preview?index=${index}`,
    },

    preview: {
      base: () => 'preview',
      path: (index: number = 0) =>
        `${RoutingPaths.tours.path()}/preview?index=${index}`,
    },

    sort: {
      base: () => 'sort',
      path: () => `${RoutingPaths.tours.path()}/sort`,
    },

    clientData: {
      base: () => 'client-data',
      path: () => `${RoutingPaths.tours.path()}/client-data`,
    },

    scanPassword: {
      base: () => 'scan-password',

      path: () => `/${RoutingPaths.tours.base()}/scan-password`,
    },

    hotelRooms: {
      base: () => 'hotel-rooms',
      path: () => `${RoutingPaths.tours.path()}/hotel-rooms`,
    },

    hotelRoomDetails: {
      base: () => 'hotel-room-details',
      path: () => `${RoutingPaths.tours.path()}/hotel-room-details`,
    },

    flightSelection: {
      base: () => 'flight-selection',
      path: () => `${RoutingPaths.tours.path()}/flight-selection`,
    },

    flightDetails: {
      base: () => 'flight-details',
      path: () => `${RoutingPaths.tours.path()}/flight-details`,
    },

    applicationConfirmation: {
      base: () => 'application-confirmation/:appealId',
      path: (appealId: string) =>
        `${RoutingPaths.tours.path()}/application-confirmation/${appealId}`,
    },

    myOrderDetails: {
      base: () => 'my-order-details/:appealId',
      path: (appealId: string) =>
        `${RoutingPaths.tours.path()}/my-order-details/${appealId}`,
    },

    documentDetails: {
      base: () => 'document/:documentId',
      path: (documentId: string) =>
        `${RoutingPaths.tours.path()}/document/${documentId}`,
      partialPayment: {
        base: () => 'document/:documentId/partial-payment',
        path: (documentId: string) =>
          `${RoutingPaths.tours.documentDetails.path(documentId)}/partial-payment`,
      },
      paymentHistory: {
        base: () => 'document/:documentId/payment-history',
        path: (documentId: string) =>
          `${RoutingPaths.tours.documentDetails.path(documentId)}/payment-history`,
      },
      tourists: {
        base: () => 'document/:documentId/tourists',
        path: (documentId: string) =>
          `${RoutingPaths.tours.documentDetails.path(documentId)}/tourists`,
      },
    },

    success: {
      base: () => 'success',
      path: () => `${RoutingPaths.tours.path()}/success`,
    },

    hotelMap: {
      base: () => 'hotel-map',
      path: () => `${RoutingPaths.tours.path()}/hotel-map`,
    },

    hotTours: {
      base: () => 'hot-tours',
      path: () => `${RoutingPaths.tours.path()}/hot-tours`,
    },

    hotTourDetailPage: {
      base: () => 'hot-tour-detail/:hotelId',
      path: (hotelId?: number) =>
        `${RoutingPaths.tours.path()}/hot-tour-detail/${hotelId}`,
    },

    roomFilter: {
      base: () => 'room-filter',
      path: () => `${RoutingPaths.tours.path()}/room-filter`,
    },
  },
  beket: {
    start: () => '/',

    base: () => Beket,

    path: () => `/${Beket}`,

    search: {
      base: () => 'search',

      path: () => `${RoutingPaths.beket.path()}/search`,
    },

    searchDirection: {
      base: () => 'search-direction/:direction',

      path: (direction: string) =>
        `${RoutingPaths.beket.path()}/search-direction/${direction}`,
    },

    calendar: {
      base: () => 'calendar-range',

      path: () => `${RoutingPaths.beket.path()}/calendar-range`,
    },

    myTickets: {
      base: () => 'my_tickets',

      path: () => `${RoutingPaths.beket.path()}/my_tickets`,

      detail: {
        base: () => 'my_ticket/:id/*',

        path: (id: string, isArchive?: boolean) =>
          `${RoutingPaths.beket.path()}/my_ticket/${id}${isArchive ? `/?isArchive=true` : ''}`,
      },
    },

    order: {
      base: () => 'order',

      path: () => `${RoutingPaths.beket.path()}/order`,
    },

    orders: {
      base: () => 'orders',

      path: () => `${RoutingPaths.beket.path()}/orders`,
    },

    ordersArchive: {
      base: () => 'orders-archive',

      path: () => `${RoutingPaths.beket.path()}/orders-archive`,
    },

    tripDetails: {
      base: () => 'trip-details/:ticketId',
      path: (ticketId: string) =>
        `${RoutingPaths.beket.path()}/trip-details/${ticketId}`,
    },

    check: {
      base: () => 'check',
      path: () => `${RoutingPaths.beket.path()}/check`,
    },

    schemeOrder: {
      base: () => 'scheme-order/:ticketId',
      path: (ticketId: string) =>
        `${RoutingPaths.beket.path()}/scheme-order/${ticketId}`,
    },

    searchResults: {
      base: () => 'search-results',
      path: () => `${RoutingPaths.beket.path()}/search-results`,
    },

    searchResultsWidget: {
      base: () => 'search-results/:params',
      path: (params: string) =>
        `${RoutingPaths.beket.path()}/search-results/${params}`,
    },

    searchForm: {
      base: () => 'search-form',
      path: () => `${RoutingPaths.beket.path()}/search-form`,
    },

    mplus: {
      base: () => 'mplus',
      path: (isSearch?: boolean) =>
        `${RoutingPaths.beket.path()}/mplus/${isSearch ? `?search=true` : ''}`,
    },
  },
  umrah: {
    start: () => '/',

    base: () => Umrah,

    path: () => `/${Umrah}`,

    tourDetail: {
      base: () => 'tour-detail/:id/:scheduleId',

      path: (tourId: string, scheduleId: string) =>
        `${RoutingPaths.umrah.path()}/tour-detail/${tourId}/${scheduleId}`,
    },

    gallery: {
      base: () => 'gallery',

      path: () => `${RoutingPaths.umrah.path()}/gallery`,
    },

    preview: {
      base: () => 'preview',
      path: (index: number = 0) =>
        `${RoutingPaths.umrah.path()}/preview?index=${index}`,
    },

    prepayment: {
      base: () => 'prepayment',
      path: () => `${RoutingPaths.umrah.path()}/prepayment`,
    },

    myOrderDetails: {
      base: () => 'my-order-details/:orderId',
      path: (orderId: string) =>
        `${RoutingPaths.umrah.path()}/my-order-details/${orderId}`,
    },
  },

  kyrgyzstan: {
    start: () => '/',

    base: () => Kyrgyzstan,

    path: () => `/${Kyrgyzstan}`,

    calendar: {
      base: () => 'calendar',

      path: () => `/${Kyrgyzstan}/calendar`,
    },

    selectGuests: {
      base: () => 'select-guests',

      path: () => `/${Kyrgyzstan}/select-guests`,
    },

    selectGuestsBooking: {
      base: () => 'select-guests-booking',

      path: () => `/${Kyrgyzstan}/select-guests-booking`,
    },

    calendarBooking: {
      base: () => 'calendar-booking',

      path: () => `/${Kyrgyzstan}/calendar-booking`,
    },

    filters: {
      base: () => 'filters',

      path: () => `/${Kyrgyzstan}/filters`,
    },

    searchResult: {
      base: () => 'search-result',

      path: () => `/${Kyrgyzstan}/search-result`,
    },

    searchForm: {
      base: () => 'search-form',

      path: () => `/${Kyrgyzstan}/search-form`,
    },

    searchDirection: {
      base: () => 'search-direction',

      path: () => `/${Kyrgyzstan}/search-direction`,
    },

    sort: {
      base: () => 'sort',

      path: () => `/${Kyrgyzstan}/sort`,
    },

    detail: {
      base: () => 'detail/:id',

      path: (id: string) => `/${Kyrgyzstan}/detail/${id}`,
    },

    detailShare: {
      base: () => 'detail-share/:id',

      path: (id: string) => `/${Kyrgyzstan}/detail-share/${id}`,
    },

    detailView: {
      base: () => 'detail-view/:id',

      path: (id: string) => `/${Kyrgyzstan}/detail-view/${id}`,
    },

    allAmenities: {
      base: () => 'all-amenities/:id',

      path: (id: string) => `/${Kyrgyzstan}/all-amenities/${id}`,
    },

    booking: {
      base: () => 'booking',

      path: () => `/${Kyrgyzstan}/booking`,
    },

    myOrders: {
      base: () => 'my-orders',

      path: () => `/${Kyrgyzstan}/my-orders`,

      detail: {
        base: () => 'my-orders/:orderId',

        path: (orderId: string) =>
          `${RoutingPaths.kyrgyzstan.path()}/my-orders/${orderId}`,
      },

      cancelBooking: {
        base: () => 'my-orders/:orderId/cancel',

        path: (orderId: string) =>
          `${RoutingPaths.kyrgyzstan.path()}/my-orders/${orderId}/cancel`,
      },

      cancelBookingSuccess: {
        base: () => 'my-orders/:orderId/cancel/success',

        path: (orderId: string) =>
          `${RoutingPaths.kyrgyzstan.path()}/my-orders/${orderId}/cancel/success`,
      },

      gallery: {
        base: () => 'my-orders/:orderId/gallery',

        path: (orderId: string) =>
          `${RoutingPaths.kyrgyzstan.path()}/my-orders/${orderId}/gallery`,
      },

      galleryImage: {
        base: () => 'my-orders/:orderId/gallery/:imageIndex',

        path: (orderId: string, imageIndex: string) =>
          `${RoutingPaths.kyrgyzstan.path()}/my-orders/${orderId}/gallery/${imageIndex}`,
      },
    },

    objects: {
      base: () => 'objects',

      path: () => `${RoutingPaths.kyrgyzstan.path()}/objects`,

      bookings: {
        base: () => `${RoutingPaths.kyrgyzstan.objects.base()}/bookings`,

        path: () => `${RoutingPaths.kyrgyzstan.objects.path()}/bookings`,

        history: {
          base: () =>
            `${RoutingPaths.kyrgyzstan.objects.bookings.base()}/history`,

          path: () =>
            `${RoutingPaths.kyrgyzstan.objects.bookings.path()}/history`,
        },
      },

      create: {
        base: () => `${RoutingPaths.kyrgyzstan.objects.base()}/new`,

        path: () => `${RoutingPaths.kyrgyzstan.objects.path()}/new`,

        step: {
          base: () =>
            `${RoutingPaths.kyrgyzstan.objects.create.base()}/step/:stepId`,

          path: (stepId: CreateObjectStepId) =>
            `${RoutingPaths.kyrgyzstan.objects.create.path()}/step/${stepId}`,
        },

        submitted: {
          base: () =>
            `${RoutingPaths.kyrgyzstan.objects.create.base()}/submitted`,

          path: () =>
            `${RoutingPaths.kyrgyzstan.objects.create.path()}/submitted`,
        },
      },

      edit: {
        base: () => `${RoutingPaths.kyrgyzstan.objects.base()}/:objectId/edit`,

        path: (objectId: string) =>
          `${RoutingPaths.kyrgyzstan.objects.path()}/${objectId}/edit`,

        step: {
          base: () =>
            `${RoutingPaths.kyrgyzstan.objects.edit.base()}/step/:stepId`,

          path: (objectId: string, stepId: CreateObjectStepId) =>
            `${RoutingPaths.kyrgyzstan.objects.edit.path(objectId)}/step/${stepId}`,
        },
      },

      draftRevision: {
        base: () =>
          `${RoutingPaths.kyrgyzstan.objects.base()}/draft-revisions/:draftId/edit`,

        path: (draftId: string) =>
          `${RoutingPaths.kyrgyzstan.objects.path()}/draft-revisions/${draftId}/edit`,

        step: {
          base: () =>
            `${RoutingPaths.kyrgyzstan.objects.draftRevision.base()}/step/:stepId`,

          path: (draftId: string, stepId: CreateObjectStepId) =>
            `${RoutingPaths.kyrgyzstan.objects.draftRevision.path(draftId)}/step/${stepId}`,
        },
      },
    },

    optionDetail: {
      base: () => 'option/:id',

      path: (id: string) => `/${Kyrgyzstan}/option/${id}`,
    },

    optionDetailView: {
      base: () => 'option-view/:id',
      path: (id: string) => `/${Kyrgyzstan}/option-view/${id}`,
    },

    optionDetailGallery: {
      base: () => 'option/:id/gallery',

      path: (id: string) => `/${Kyrgyzstan}/option/${id}/gallery`,
    },

    optionDetailGalleryImage: {
      base: () => 'option/:id/gallery/:imageIndex',

      path: (id: string, imageIndex: string) =>
        `/${Kyrgyzstan}/option/${id}/gallery/${imageIndex}`,
    },

    gallery: {
      base: () => 'gallery/:id',

      path: (id: string) => `/${Kyrgyzstan}/gallery/${id}`,
    },

    galleryImage: {
      base: () => 'gallery/:id/:imageIndex',

      path: (id: string, imageIndex: string) =>
        `/${Kyrgyzstan}/gallery/${id}/${imageIndex}`,
    },

    map: {
      base: () => 'map/:id',

      path: (id: string) => `/${Kyrgyzstan}/map/${id}`,
    },

    bestOffers: {
      base: () => 'best-offers',

      path: () => `/${Kyrgyzstan}/best-offers`,
    },

    collections: {
      base: () => 'collections/:id',

      path: (id: string) => `/${Kyrgyzstan}/collections/${id}`,
    },

    restPlaces: {
      base: () => 'rest-places',

      path: () => `/${Kyrgyzstan}/rest-places`,
    },
  },
}
